// src/components/product-type.ts
var ProductType = /* @__PURE__ */function (ProductType2) {
  ProductType2["GroundTransportation"] = "GroundTransportation";
  ProductType2["Lodging"] = "Lodging";
  ProductType2["Cruise"] = "Cruise";
  ProductType2["Activities"] = "Activities";
  ProductType2["Cars"] = "Cars";
  return ProductType2;
}(ProductType || {});
// src/components/product-type-context.ts
import { createContext } from "react";
var ProductTypeContext = createContext(null);
// src/components/product-type-provider.tsx
import React from "react";
var Provider = ProductTypeContext.Provider;
var ProductTypeProvider = function (param) {
  var productType = param.productType,
    mockData = param.mockData,
    children = param.children;
  return /* @__PURE__ */React.createElement(Provider, {
    value: {
      productType: productType,
      mockData: mockData
    }
  }, children);
};
// src/components/use-product-type.ts
import { useContext } from "react";
var _useContext_productType;
var useProductType = function () {
  var _useContext;
  return (_useContext_productType = (_useContext = useContext(ProductTypeContext)) === null || _useContext === void 0 ? void 0 : _useContext.productType) !== null && _useContext_productType !== void 0 ? _useContext_productType : null;
};
var _useContext_mockData;
var useMockData = function () {
  var _useContext;
  return (_useContext_mockData = (_useContext = useContext(ProductTypeContext)) === null || _useContext === void 0 ? void 0 : _useContext.mockData) !== null && _useContext_mockData !== void 0 ? _useContext_mockData : null;
};
export { ProductType, ProductTypeContext, ProductTypeProvider, useMockData, useProductType };